export const AsyncWrapperStyles = () => {
    return {
        height: "100%",
        "& .async-wrapper": {
            position: "relative",
            height: "100%",
            width: "100%",

            "& .async-wrapper__loading ": {
                alignItems: "center",
                display: "flex",
                height: "100%",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "center",
                position: "relative",
            },
            "& .loading": {
                "& .loading__message": {
                    color: "#1f1646",
                    marginBottom: "10px",

                    "&. loading-label": {
                        fontWeight: "bold",
                        fontStyle: "italic",
                    },
                },
                "& .loading__animation": {
                    color: "#773dbd",
                }
            },
        }
    }
}
